import React, { useContext, useState } from 'react'
import styles from './Media.module.css'
import { ScoreCardContext } from '../../store/scorecard-context'

const Ratings = ({avgQAScore}: any) => {

    const scorecardCtx = useContext(ScoreCardContext)

    const [isAverageBlockShow, setIsAverageBlockShow] = useState(false)

    const toggleAverageBlock = () => {
        setIsAverageBlockShow(!isAverageBlockShow)
    }

    const getWeightedAverageScore = () => {
        const sections = scorecardCtx?.scores?.sections
        if (!sections || !sections.length) return undefined

        const totalWeight = sections.reduce((sum: number, section: any) => sum + (section.weight || 0), 0)
        if (!totalWeight) return undefined

        const weightedSum = sections.reduce((sum: number, section: any) => sum + (section.review_score || 0) * (section.weight || 0), 0)
        return weightedSum / totalWeight
    }

    return (
        <div className={`${styles.ratingsContainer} p-3`}>
            {
                <div className="text-center">
                    <div className="row">
                        <div className={`col ${styles.rating} position-relative`}>
                            <div>
                                <div className="d-flex justify-content-center">
                                    <span>
                                        {
                                            (() => {
                                                const averageScore = getWeightedAverageScore()

                                                if (averageScore === undefined) return '-'
                                                return averageScore < 0 ? '0' : `${Math.round(averageScore)}`
                                            })()
                                        }
                                    </span>
                                </div>                       
                            </div>
                            <h6 className="mt-2 m-0">QA Score</h6>
                            
                        </div>
                        <div className={`col ${styles.rating}`}>
                            <div>
                                <span>-</span>
                            </div>
                            <h6 className="mt-2 m-0">CSAT</h6>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Ratings
